import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useRef, useState 
} from "react"
import ADD_WEDDINGPLANNER from "./weddingPlannersPro.gql"

export const useWeddingPlannersPro = (props) => {
  const {
    headslider 
  } = props
  const operations = mergeOperations(ADD_WEDDINGPLANNER, props.operations)
  const formApiRef = useRef(null)
  const {
    addWeddingPlannerMutation 
  } = operations
  const [isLoading, setIsLoading] = useState(false)
  const [slickIndex, setSlickIndex] = useState(0)
  const [animate, setAnimate] = useState(0)
  const [addWeddingPlanner, {
    data 
  }] = useMutation(
    addWeddingPlannerMutation,
    {
      fetchPolicy: "no-cache",
    }
  )
  const activeItem = useCallback(
    (index) => {
      headslider.current.slickGoTo(index)
      setSlickIndex(index)
      setAnimate(1)
      setTimeout(() => {
        setAnimate(0)
      }, 800)
    },
    [setSlickIndex]
  )
  const handleSubmit = useCallback(
    async (formState) => {
      setIsLoading(true)

      try {
        await addWeddingPlanner({
          variables: formState.values,
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addWeddingPlanner]
  )

  return {
    formApiRef,
    isLoading,
    handleSubmit,
    slickIndex,
    setSlickIndex,
    activeItem,
    animate,
    setAnimate,
    response: data && data.addWeddingPlanner,
  }
}
